module.exports = __webpack_public_path__ + "static/media/spa-xs.8c7a7646.jpg";